<template>
  <div class="form-progress mb40 mb80-lg">
    <template
      v-for="(step, index) in totalSteps"
      :key="index"
    >
      <div class="form-progress__step ts-step-indicator" :class="{
        'active': index + 1 === currentStep,
        'completed': index + 1 < currentStep
      }">{{ index + 1 }}</div>
      <div class="form-progress__line" v-if="index + 1 < totalSteps"></div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'VueFormProgress',

  props: {
    totalSteps: {
      type: Number,
      default: 1
    },
    currentStep: {
      type: Number,
      default: 1
    },
  },
}
</script>

<style lang="scss">
.form-progress {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  &__step {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 1px solid var(--color-dark-green);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.15s ease-in, color 0.15s ease-in;
    user-select: none;

    &.completed,
    &.active {
      background-color: var(--color-dark-green);
      color: var(--color-green);
    }
  }

  &__line {
    border-top: 1px dashed var(--color-dark-green);
    height: 0;
    flex-grow: 1;
  }
}
</style>
